export default "__VITE_ASSET__DBSQyja___"